var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_9865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 5.14286C17.1428 4.51168 16.6312 4 16 4C15.3688 4 14.8571 4.51168 14.8571 5.14286V10.2857C14.8571 10.6329 15.0149 10.9613 15.286 11.1782L18.1432 13.4639C18.6361 13.8582 19.3553 13.7783 19.7496 13.2854C20.1439 12.7925 20.064 12.0733 19.5711 11.679L17.1428 9.73646V5.14286Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 10.2857C5.71429 4.60507 10.3193 0 16 0C21.6807 0 26.2857 4.60507 26.2857 10.2857C26.2857 15.9664 21.6807 20.5714 16 20.5714C10.3193 20.5714 5.71429 15.9664 5.71429 10.2857ZM16 2.28571C11.5817 2.28571 8.00001 5.86744 8.00001 10.2857C8.00001 14.704 11.5817 18.2857 16 18.2857C20.4183 18.2857 24 14.704 24 10.2857C24 5.86744 20.4183 2.28571 16 2.28571Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57145 26.2856C3.94027 26.2856 3.42859 26.7973 3.42859 27.4285C3.42859 28.0597 3.94027 28.5714 4.57145 28.5714H11.4286C12.0598 28.5714 12.5714 28.0597 12.5714 27.4285C12.5714 26.7973 12.0598 26.2856 11.4286 26.2856H4.57145Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57143 22.8569C2.0467 22.8569 0 24.9037 0 27.4284C0 29.953 2.0467 31.9998 4.57143 31.9998H27.4286C29.9533 31.9998 32 29.953 32 27.4284C32 24.9037 29.9533 22.8569 27.4286 22.8569H4.57143ZM2.28571 27.4284C2.28571 26.166 3.30906 25.1426 4.57143 25.1426H27.4286C28.691 25.1426 29.7143 26.166 29.7143 27.4284C29.7143 28.6908 28.691 29.7141 27.4286 29.7141H4.57143C3.30906 29.7141 2.28571 28.6908 2.28571 27.4284Z",
    fill: "#0000FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_9865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.d7feef372fa448751ea76cd04c0d55a3.svg";
export { ForwardRef as ReactComponent };